import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import { buildOfferAnalyticsBaseParams } from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
}

export const trackOfferSkip = ({ offerKey }: Params) =>
  track({ event: "offer_skip", ...buildOfferAnalyticsBaseParams(offerKey) });
